/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface NotificationMethodDto
 */
export interface NotificationMethodDto {
    /**
     *
     * @type {string}
     * @memberof NotificationMethodDto
     */
    method?: NotificationMethodDtoMethodEnum;
    /**
     *
     * @type {string}
     * @memberof NotificationMethodDto
     */
    description?: string;
    /**
     *
     * @type {boolean}
     * @memberof NotificationMethodDto
     */
    isEnabled?: boolean;
}

/**
 * @export
 */
export const NotificationMethodDtoMethodEnum = {
    Unknown: "Unknown",
    Email: "Email",
    Sms: "SMS",
    PushNotification: "PushNotification",
} as const;
export type NotificationMethodDtoMethodEnum =
    (typeof NotificationMethodDtoMethodEnum)[keyof typeof NotificationMethodDtoMethodEnum];

/**
 * Check if a given object implements the NotificationMethodDto interface.
 */
export function instanceOfNotificationMethodDto(
    value: object,
): value is NotificationMethodDto {
    return true;
}

export function NotificationMethodDtoFromJSON(
    json: any,
): NotificationMethodDto {
    return NotificationMethodDtoFromJSONTyped(json, false);
}

export function NotificationMethodDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): NotificationMethodDto {
    if (json == null) {
        return json;
    }
    return {
        method: json["method"] == null ? undefined : json["method"],
        description:
            json["description"] == null ? undefined : json["description"],
        isEnabled: json["isEnabled"] == null ? undefined : json["isEnabled"],
    };
}

export function NotificationMethodDtoToJSON(
    value?: NotificationMethodDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        method: value["method"],
        description: value["description"],
        isEnabled: value["isEnabled"],
    };
}
